const BASE = '/api';

async function request(path, options = {}) {
  const res = await fetch(BASE + path, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Error en la solicitud');
  }
  return res.json();
}

export const api = {
  // Recepciones
  getRecepciones: (q = '') => request(`/recepciones${q ? '?q=' + encodeURIComponent(q) : ''}`),
  crearRecepcion: (data) => request('/recepciones', { method: 'POST', body: JSON.stringify(data) }),
  previewLote: (tipo) => request(`/recepciones/preview-lote/${tipo}`),

  // Lotes
  getLotes: (q = '', estado = '') => {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (estado) params.set('estado', estado);
    return request(`/lotes${params.toString() ? '?' + params : ''}`);
  },

  // Pedidos
  getPedidos: () => request('/pedidos'),
  crearPedido: (data) => request('/pedidos', { method: 'POST', body: JSON.stringify(data) }),
  actualizarPedido: (id, estado, responsable) =>
    request(`/pedidos/${id}/estado`, { method: 'PATCH', body: JSON.stringify({ estado, responsable }) }),

  // Eventos
  getEventos: (q = '') => request(`/eventos${q ? '?q=' + encodeURIComponent(q) : ''}`),

  // Maestro productos SAP
  getProductos: (q = '', categoria = '') => {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (categoria) params.set('categoria', categoria);
    return request(`/productos${params.toString() ? '?' + params : ''}`);
  },
  syncSAP: () => request('/productos/sync', { method: 'POST' }),

  // Stock
  getStock: () => request('/stock'),
};
